import { Component } from '@angular/core';
import { ApiService } from '../services/api/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../shared/shared.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { EreceiptDialogsComponent } from '../components/dialogs/ereceipt-dialogs/ereceipt-dialogs.component';
import { forkJoin } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ereceipt',
  templateUrl: './ereceipt.component.html',
  styleUrls: ['./ereceipt.component.scss']
})
export class EreceiptComponent {

  param: any;
  version: any;
  receiptDisplay: any;
  htmlContent: any;
  displayNotReadyPage: boolean = true;
  displayRefreshButton: boolean = true;
  message = "";
  loading: boolean = false;
  displayEmail: boolean = false;
  displayDownload: boolean = false;
  env = environment;
  constructor(
      public apiService: ApiService,
      private activatedRoute: ActivatedRoute,
      private route: Router,
      private sanitizer: DomSanitizer,
      private snackBar: MatSnackBar,
      private matDialog: MatDialog
  ){
    this.param = this.activatedRoute.snapshot.queryParamMap.get('id');
    this.version = this.activatedRoute.snapshot.queryParamMap.get('v');
  }

  ngOnInit(){
    if (this.param == null || this.param == ''){
      this.displayNotReadyPage = true;
      this.displayRefreshButton = false;
      this.message = "The receipt you're looking for doesn't exist.";
      // this.route.navigate(['/error']);
    }
    else {
      this.getReceiptData();
    }
  }

  getReceiptData(){
  this.loading = true;
    try {
      let ver = this.version != null && this.version != '' ? this.version : '1';
      let getStoreCode = this.param.split("-")[0];
      // console.log(getStoreCode)

      forkJoin({
        receiptData:  this.apiService.getReceiptData(this.param, ver),
        setting: this.apiService.getEReceiptSetting(getStoreCode)
      }).subscribe(res => {
        this.loading = false;

        // console.log(res);

        const contentType = res.receiptData?.headers.get('Content-Type');
        if (contentType?.includes('text/html')){
          this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(res.receiptData?.body);
          this.displayNotReadyPage = false;
        }
        else if (contentType?.includes('application/json')){
          let getResult = JSON.parse(res.receiptData?.body);
          this.displayNotReadyPage = true;
          this.message = getResult.data?.message;
        }


        if (res.setting?.success == true){
          this.displayEmail = res.setting?.data?.is_email_enabled;
          this.displayDownload = res.setting?.data?.is_pdf_enabled;
        }
        else {
          this.displayEmail = false;
          this.displayDownload = false;
        }
        


      }, (error) => {
        // console.log(error);
        this.loading = false;
        this.displayNotReadyPage = true;
        this.displayRefreshButton = true;
        this.message = "The receipt you're looking for doesn't exist.";
        this.displayDownload = false;
        this.displayEmail = false;
      })
    }
    catch(e){
      console.log(e);
      this.loading = false;
      this.displayNotReadyPage = true;
      this.displayRefreshButton = true;
      this.message = "The receipt you're looking for doesn't exist.";
      this.displayDownload = false;
      this.displayEmail = false;
    }
  }

  downloadPDF(){
    // this.apiService.downloadReceipt(this.param);
    this.loading = true;
    this.apiService.downloadReceipt(this.param).subscribe(result => {
      this.loading = false;
      const blobUrl = window.URL.createObjectURL(result);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = 'e-receipt-' + this.param + '.pdf';  // Set the filename
      document.body.appendChild(a);

      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
    }, (err)=> {
        this.loading = false;
        this.snackBar.open("Unable to download e-receipt. Please try again later", "Close", {
          duration: 3000,
          panelClass: ['snackbar']
        });
    })
  }

  refresh(){
    window.location.reload();
  }

  emailReceipt(){
    const dialogEmail = this.matDialog.open(EreceiptDialogsComponent);

    dialogEmail.afterClosed().subscribe(res => {
      if (res?.proceed == true){
        // console.log(res);
        this.loading = true;

        let apiData = {
          receipt_no: this.param,
          email: res?.email
        };

        this.apiService.emailReceipt(apiData).subscribe(result => {
          // console.log(result);
          this.loading = false;
          if (result.success == true){
            this.snackBar.open(result.data?.message, "Close", {
              duration: 5000,
              panelClass: ['snackbar']
            });
          }
          else {

          }
        }, (err)=> {
            this.loading = false;
            // console.log(err);
            this.snackBar.open(err?.error?.message, "Close", {
              duration: 3000,
              panelClass: ['snackbar']
            });
        })

      }
    })
  }
}
